export default __webpack_public_path__ + "static/media/planet3.5f41aef4.png";